<abc-grid
  #documentGrid
  class="dl-grid-style"
  [showBorders]="true"
  [showRowLines]="true"
  [showColumnLines]="true"
  [hoverStateEnabled]="true"
  [columns]="columnsHeader"
  [dataSource]="dataSource"
  [(selectedRowKeys)]="selectedDocumentsIds"
  [keyExpr]="'Id'"
  [height]="height"
  (onRowDblClick)="onRowDblClick($event)"
  (onSelectionChanged)="changeRowSelection($event)"
  >
  <dxo-load-panel [enabled]="gridOptions.enableLoadPanel"></dxo-load-panel>
  <dxo-group-panel [visible]="gridOptions.isGroupPanelVisible"> </dxo-group-panel>
  <dxo-filter-row [visible]="gridOptions.isFilterRowVisible"></dxo-filter-row>
  <dxo-filter-panel [visible]="gridOptions.isFilterPanelVisible"></dxo-filter-panel>
  <dxo-filter-builder-popup [(visible)]="filterBuilderVisible"> </dxo-filter-builder-popup>
  <dxo-selection [mode]="allowMultipleSelection ? 'multiple' : 'none'" [showCheckBoxesMode]="'always'"></dxo-selection>
  <dxo-export
    [enabled]="gridOptions.enableExport"
    [allowExportSelectedData]="gridOptions.allowExportSelectedData"
  ></dxo-export>
  <dxo-header-filter [visible]="gridOptions.isHeaderFilterVisible"></dxo-header-filter>
  <dxo-scrolling [mode]="gridOptions.scrollingMode"></dxo-scrolling>
  <dxo-paging [enabled]="gridOptions.enablePaging"></dxo-paging>
  <dxo-search-panel [visible]="allowSearch" [highlightCaseSensitive]="true"></dxo-search-panel>
  <dxo-column-chooser
    [mode]="gridOptions.columnChooserMode"
    [enabled]="gridOptions.enableColumnChooser"
    [sortOrder]="gridOptions.columnChooserSortOrder"
    >
  </dxo-column-chooser>

  @if (gridOptions.filterPanelMode !== defaultFilterPanelMode) {
    <dxo-toolbar>
      @if (gridOptions.isGroupPanelVisible) {
        <dxi-item name="groupPanel" location="before"></dxi-item>
      }
      @if (gridOptions.enableExport) {
        <dxi-item name="exportButton" location="after"></dxi-item>
      }
      @if (gridOptions.filterPanelMode !== defaultFilterPanelMode) {
        <dxi-item location="after">
          <abc-button [icon]="'filter'" [hint]="labels.Filter" (onClick)="openFilterBuilder()"></abc-button>
        </dxi-item>
      }
      @if (gridOptions.enableColumnChooser) {
        <dxi-item name="columnChooserButton" location="after"></dxi-item>
      }
      @if (allowSearch) {
        <dxi-item name="searchPanel" location="after"></dxi-item>
      }
    </dxo-toolbar>
  }

  <div *dxTemplate="let document of 'buttons'">
    @if (!actionsContextMenu) {
      <div class="dl-grid-actions">
        @for (specificBtnItem of specificButtonsValue; track $index) {
          @if (specificBtnItem.visible) {
            <abc-button [stylingMode]="'text'" [class]="specificBtnItem.class"
              [hint]="specificBtnItem.text" [icon]="specificBtnItem.icon" (onClick)="specificBtnItem.onClick(document.data)">
            </abc-button>
          }
        }
        @if (document.data.allowPreview) {
          <abc-button
            [stylingMode]="'text'"
            [hint]="labels.Preview"
            class="dl-preview-btn"
            [icon]="'fullscreen'"
            (onClick)="previewDocument.emit(document.data.Id)"
            >
          </abc-button>
        }
        @if (document.data.allowDownload) {
          <abc-button
            [stylingMode]="'text'"
            [hint]="labels.Download"
            class="dl-download-btn"
            [icon]="'spindown'"
            (onClick)="downloadDocument.emit(document.data.Id)"
            >
          </abc-button>
        }
        @if (document.data.allowDelete) {
          <abc-button
            [stylingMode]="'text'"
            [hint]="labels.Delete"
            class="dl-delete-btn"
            [icon]="'trash'"
            (onClick)="openDeleteDocumentPopup.emit(document.data.Id)"
            >
          </abc-button>
        }
        @if (document.data.allowDetails) {
          <abc-button
            [stylingMode]="'text'"
            [hint]="labels.Details"
            class="dl-details-btn"
            [icon]="'chevronright'"
            (onClick)="goToDetails.emit(document.data.Id)"
            >
          </abc-button>
        }
      </div>
    }
    @if (actionsContextMenu) {
      <abc-button
        [id]="'actionItems' + document.data.Id"
        [stylingMode]="'text'"
        [hint]="labels.Actions"
        class="dl-context-menu-btn"
        [icon]="isContextMenuVisible && document.data.Id === selectedDocument?.Id ? 'close' : 'overflow'"
        (onClick)="onOpenActionButtonsMenu($event, document.data)"
        >
      </abc-button>
    }
  </div>
</abc-grid>
